import { useState, useEffect } from 'react';

export const useGlossary = () => {
  const [glossaryTerms, setGlossaryTerms] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadGlossary = async () => {
      // Step 1: First try direct CDN URL
      try {
        console.log('Trying to fetch glossary directly from CDN...');
        const cdnResponse = await fetch('https://om-assets.fra1.cdn.digitaloceanspaces.com/assets/glossary/glossary.json');
        
        if (!cdnResponse.ok) {
          throw new Error(`Failed to fetch from CDN: ${cdnResponse.status}`);
        }
        
        const cdnData = await cdnResponse.json();
        console.log('Glossary loaded successfully from CDN with', Object.keys(cdnData).length, 'entries');
        setGlossaryTerms(cdnData);
        setIsLoading(false);
        return;
      } catch (cdnError) {
        console.error('Error loading glossary from CDN:', cdnError);
        // Fall through to API attempt
      }
      
      // Step 2: Try the API endpoint
      try {
        console.log('Falling back to API endpoint...');
        const apiResponse = await fetch('/api/glossary');
        
        if (!apiResponse.ok) {
          throw new Error(`Failed to fetch from API: ${apiResponse.status}`);
        }
        
        const apiData = await apiResponse.json();
        console.log('Glossary loaded from API with', Object.keys(apiData).length, 'entries');
        setGlossaryTerms(apiData);
        setIsLoading(false);
        return;
      } catch (apiError) {
        console.error('Error loading glossary from API:', apiError);
        // Fall through to local file attempt
      }
      
      // Step 3: Try the local file as last resort
      try {
        console.log('Falling back to local glossary copy...');
        const localResponse = await fetch('/assets/glossary.json');
        
        if (!localResponse.ok) {
          throw new Error(`Failed to fetch local glossary: ${localResponse.status}`);
        }
        
        const localData = await localResponse.json();
        console.log('Glossary loaded from local file with', Object.keys(localData).length, 'entries');
        setGlossaryTerms(localData);
      } catch (localError) {
        console.error('Error loading fallback glossary:', localError);
        console.warn('All glossary loading attempts failed. Using empty glossary.');
        setGlossaryTerms({}); // Empty object as last resort
      } finally {
        setIsLoading(false);
      }
    };

    loadGlossary();
  }, []);

  return { glossaryTerms, isLoading };
};